import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const uiSlice = createSlice({
  name: 'ui',
  initialState: { pageTitle: '' },
  reducers: {
    setPageTitle: (state, action: PayloadAction<string>) => {
      state.pageTitle = action.payload
    },
    clearPageTitle: (state) => {
      state.pageTitle = ''
    },
  },
})

export const { setPageTitle, clearPageTitle } = uiSlice.actions
export default uiSlice.reducer
